import { render, staticRenderFns } from "./CreateRestream.vue?vue&type=template&id=3839aa52&scoped=true&"
import script from "./CreateRestream.vue?vue&type=script&lang=js&"
export * from "./CreateRestream.vue?vue&type=script&lang=js&"
import style0 from "./CreateRestream.vue?vue&type=style&index=0&id=3839aa52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3839aa52",
  null
  
)

export default component.exports